<template>
	<div :class="{ hidden: !showModal, 'main-modal': true }">
		<div class="main-modal-header">
			<div class="main-modal-right">
				<button @click="toggleSelectCompetencyTests">
					<b-icon icon="chevron-down"></b-icon>
				</button>
			</div>
		</div>
		<div class="main-modal-content">
			<div class="alert alert-warning mt-3" v-if="!treatmentsession.student">
				{{ $t("please-select-a-student-before-adding-competency-tests") }}
			</div>

			<div v-if="treatmentsession.student">
				<div class="mt-4">
					<input
						type="search"
						v-model="filterSearch"
						data-cy="search-competency-tests"
						:placeholder="$t('enter-test-name-ellipsis')"
						class="block w-full form-control"
					/>
				</div>

				<!--
				<div v-if="filters.length" class="mt-4">
					<button
						v-for="(filter, filterIndex) in filters"
						v-bind:key="filterIndex"
						class="btn"
						:class="{
							'btn-on btn-on-good': activeFilters.includes(filter),
							'btn-secondary': !activeFilters.includes(filter),
						}"
						@click="toggleFilter(filter)"
					>
						{{ filter.competencytestfilter_caption }}
					</button>
				</div>
				-->

				<div class="form-row mt-4">
					<div class="col">
						<div class="form-group">
							<label>{{ $t("programme-year") }}</label>
							<select class="form-control" v-model="selectedProgrammeyear">
								<option :value="null">{{ $t("any") }}</option>
								<option
								v-for="programmeyear in programmeyears"
								:key="`${programmeyear.programme}-${programmeyear.year}`"
								:value="`${programmeyear.programme}-${programmeyear.year}`"
								>{{ programmeyear.title }}
								</option>
							</select>
						</div>
					</div>
					<div class="col">
						<div class="form-group">
							<label>{{ $t("category") }}</label>
							<select class="form-control" v-model="selectedCategory">
								<option :value="null">{{ $t("any") }}</option>
								<option
								v-for="filter in filters"
								:key="filter.competencytestfilter_id"
								:value="filter.competencytestfilter_id"
								>{{ filter.competencytestfilter_caption }}
								</option>
							</select>
						</div>
					</div>
				</div>

				<div class="list-group mt-4" data-cy="competency-test-search-results">
					<div
						v-for="(competencyTest, competencyTestIndex) in competencyTests"
						v-bind:key="competencyTestIndex"
						v-show="showTest(competencyTest)"
						class="list-group-item"
					>
						<b-row>
							<b-col col>
								<p class="mb-1 mt-1 font-bold">
									{{ competencyTest.Code }}: {{ competencyTest.Name }}
								</p>
								<p>
									{{ competencyTest.Description }}
								</p>
							</b-col>

							<b-col cols="12" md="auto">
								<button
									v-if="
										competencyTest.CanSelect === 1 &&
										competencyTest.IsSelected === 0
									"
									class="btn btn-light ml-1"
									:class="{ disabled: treatmentsession.isLocked }"
									@click="addCompetencyTest(competencyTestIndex)"
								>
									{{ competencyTest.HasPassed !== 1 ? $t("select") : $t("retake") }}
								</button>

								<button
									v-if="
										competencyTest.CanSelect === 1 &&
										competencyTest.IsSelected === 1
									"
									class="btn btn-on btn-on-good ml-1"
									:class="{ disabled: treatmentsession.isLocked }"
									@click="removeCompetencyTest(competencyTestIndex)"
								>
									{{ $t("selected") }}
								</button>

								<button
									v-if="competencyTest.CurrentHasPassed === 1"
									class="btn btn-success disabled ml-1"
								>
									{{ $t("passed") }}
								</button>

								<button
									v-if="competencyTest.RetakeFailed === 1"
									class="btn btn-danger disabled ml-1"
								>
									{{ $t("retake-failed") }}<br />
								</button>

								<button
									v-if="competencyTest.HasPassed === 0"
									class="btn btn-danger disabled ml-1"
								>
									{{ $t("failed") }}
								</button>

								<button
									v-if="
										competencyTest.HasPassed === 1 &&
										competencyTest.CurrentHasPassed !== 1
									"
									class="btn btn-light disabled ml-1"
								>
									{{ $t("passed") }}<br />
									{{ getFormattedDate(competencyTest.DateMarked, "DD/MM/YYYY") }}
								</button>
							</b-col>
						</b-row>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "treatmentsessionselectcompetencytests",
	props: {
		treatmentsession: Object,
	},
	data: function () {
		return {
			loaded: false,
			competencyTests: [],
			filters: [],
			activeFilters: [],
			filterSearch: "",
			programmeyears: [],
			user: null,
			selectedProgrammeyear: null,
			selectedCategory: null,
            submittercanedittheirfields: false
		};
	},
	mounted: function () {},
	beforeDestroy: function () {
		this.$store.state.treatmentSessionSelectCompetencyTests.showModal = false;
	},
	computed: {
		showModal() {
			if (
				this.$store.state.treatmentSessionSelectCompetencyTests.showModal &&
				!this.loaded
			) {
				this.getCompetencyTests();
			}
			return this.$store.state.treatmentSessionSelectCompetencyTests.showModal;
		},
	},
	methods: {
		showTest(test) {

			let selectedProgramme, selectedYear;
			if(this.selectedProgrammeyear) {
				[selectedProgramme, selectedYear] = this.selectedProgrammeyear.split('-')
			}

			if(
				this.selectedProgrammeyear &&
				(!Object.hasOwnProperty.call(test.programmeyears, selectedProgramme)
				|| !test.programmeyears[selectedProgramme].includes(selectedYear))
			) {
				return false;
			}

			if(this.selectedCategory && !test.Filters.includes(this.selectedCategory)) {
				return false;
			}

			return !this.filterSearch
			|| test.Name.toLowerCase().includes(this.filterSearch.toLowerCase())
			|| test.Code.toLowerCase().includes(this.filterSearch.toLowerCase())
			|| test.Description.toLowerCase().includes(this.filterSearch.toLowerCase());


		},
		getProgrammeNameById(id) {
			for (let programme of Object.values(this.$config.getValue('programmes'))) {
				if(programme.Id == id) {
					return programme.Name;
				}
			}
		},
		haveProgrammeyear(programme, year) {
			for(let programmeyear of this.programmeyears) {
				if(programmeyear.programme == programme && programmeyear.year == year) {
					return true;
				}
			}
			return false;
		},
		setProgrammeyears() {
			if(this.treatmentsession.student){
				this.$users.getUserById.call(this, this.treatmentsession.student).then(user => {
					this.user = user;
					this.programmeyears = [];
					let active;
					for(let test of this.competencyTests) {
						for(let [programme, years] of Object.entries(test.programmeyears)) {
							for(let year of years) {
								if(!this.haveProgrammeyear(programme, year)) {
									active = this.user.isStudent && (this.user.programme == programme) && (this.user.year == year);
									if(active) {
										this.selectedProgrammeyear = `${programme}-${year}`;
									}
									this.programmeyears.push({
										programme,
										year,
										title: `${this.$t('year')} ${year} ${this.getProgrammeNameById(programme)}`,
										active
									})
								}
							}
						}
					}
				});
			}
		},
		getCompetencyTests: function () {
			if (this.treatmentsession.student) {
				var treatmentSession = null;
				if (this.$route.params.treatmentsessionid) {
					treatmentSession = this.$route.params.treatmentsessionid;
				}
				this.$cfetch
					.call(
						this,
						`${this.$settings.APIBaseURL}/treatmentsessions/listcompetencytests`,
						{
							method: "post",
							data: {
								treatmentSession: treatmentSession,
								activeStudent: this.treatmentsession.student,
							},
						}
					)
					.then((json) => {
						if (json.competencyTests !== undefined) {
							this.$log.info.call(this, "Treatment session competency tests loaded");
							this.competencyTests = json.competencyTests;
							this.filters = json.filters;
							this.setProgrammeyears();
						} else {
							this.$log.error.call(
								this,
								"Could not fetch treatment session competency tests"
							);
						}
					})
					.catch((error) => {
						this.$log.error.call(this, error);
					});
			} else {
				// No student defined. This is a new session.
			}
		},
		getFormattedDate: function (datetime) {
			let date = new Date(datetime);
			return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
		},
		toggleSelectCompetencyTests: function () {
			this.$store.state.treatmentSessionSelectCompetencyTests.showModal = !this.$store.state
				.treatmentSessionSelectCompetencyTests.showModal;
		},
		addCompetencyTest: function (competencyTestIndex) {
			let competencyTest = this.competencyTests[competencyTestIndex];
			let isInTreatmentSession = false;
			if (
				this.treatmentsession.tests !== undefined &&
				this.treatmentsession.tests.length >= 1
			) {
				this.treatmentsession.tests.forEach(function (item) {
					if (item.CompetencyTestID == competencyTest.CompetencyTestID) {
						isInTreatmentSession = true;
					}
				});
			} else {
				this.treatmentsession.tests = [];
			}

			if (!isInTreatmentSession) {
				this.treatmentsession.tests.push(competencyTest);
			}
			this.competencyTests[competencyTestIndex].IsSelected = 1;
			this.tryGetForm(this.competencyTests[competencyTestIndex]);
		},
		tryGetForm(competencyTest) {
			if (competencyTest.form_id && !competencyTest.form) {
				this.$cfetch
					.call(
						this,
						`${this.$settings.APIBaseURL}/forms/getform/${competencyTest.form_id}`,
						{
							method: "post",
							cache: true,
							data: {
                               competencytestform: true 
                            },
						}
					)
					.then((json) => {
						if (json.status == "SUCCESS") {
							competencyTest.form = json.form.settings;
                            this.$emit('submittercanedittheirfields', json.form.submittercanedittheirfields);
						} else {
							this.$log.error.call(this, "Could not fetch form");
						}
					})
					.catch((error) => {
						this.$log.error.call(this, error);
					});
			}
		},
		removeCompetencyTest: function (competencyTestIndex) {
			let competencyTest = this.competencyTests[competencyTestIndex];
			let self = this;
			this.treatmentsession.tests.forEach(function (item, index) {
				if (item.CompetencyTestID == competencyTest.CompetencyTestID) {
					self.treatmentsession.tests.splice(index, 1);
				}
			});
			competencyTest.IsSelected = 0;
		},
		toggleFilter: function (filter) {
			let filterIndex = this.activeFilters.indexOf(filter);
			if (filterIndex >= 0) {
				this.activeFilters.splice(filterIndex, 1);
			} else {
				this.activeFilters.push(filter);
			}
		},
	},
};
</script>
